import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { LeagueDivisionUser } from '../league-division-user.model';

@JsonObject('LeagueDivisionUsersResultsResponse')
export class LeagueDivisionUsersResultsResponse extends ApiResultsResponse<LeagueDivisionUser> {

  @JsonProperty('results', [LeagueDivisionUser])
  override results: LeagueDivisionUser[] = [];
}
